/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidLevelingsControllerListQueryResponse, BidLevelingsControllerListQueryParams, BidLevelingsControllerList401, BidLevelingsControllerList403 } from "../../models/bidsController/BidLevelingsControllerList";

function getBidLevelingsControllerListUrl() {
  const res = { method: 'GET', url: `/api/v1/bid-levelings` as const }  
  return res
}

/**
 * @summary List a project's trades with their status and attention count
 * {@link /api/v1/bid-levelings}
 */
export async function bidLevelingsControllerList(params: BidLevelingsControllerListQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<BidLevelingsControllerListQueryResponse, ResponseErrorConfig<BidLevelingsControllerList401 | BidLevelingsControllerList403>, unknown>({ method : "GET", url : getBidLevelingsControllerListUrl().url.toString(), params, ... requestConfig })  
  return res.data
}